export default "__VITE_ASSET__DPzlEoaX__"